/**
 * Actived
 */

export default function Actived() {
    this.init = () => {
        this.activedHandle();
    };

    this.activedHandle = () => {
        let selectors = document.querySelectorAll('.jsactived');
        selectors.forEach(element => {
            let jsActivedClick = element.querySelector('.jsactived-click');
            let jsActivedTarget = element.querySelector('.jsactived-target');

            function handle() {
                if (jsActivedClick.classList.contains('active')) {
                    jsActivedClick.classList.remove('active');
                    jsActivedTarget.classList.remove('show');
                } else {
                    jsActivedClick.classList.add('active');
                    jsActivedTarget.classList.add('show');
                }
            }
            jsActivedClick && jsActivedTarget && jsActivedClick.addEventListener('click', function (e) {
                e.preventDefault();
                handle();
            })
        });
    }

}
